import '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import ahTransportUtility from '@sparta.authglobal.utilities/ah-transport-utility/dist/es6.js';
import '@sparta.global.vendors/jquery';

/**
 * Utility ah-webbio-utility
 * @name        Ah Webbio Utility
 * @description used for web bio
 * @copyright   2021-9-9
 * @file        ah-webbio-utility.js
 * @classdesc   used for web bio
 * @global      Creates a global AhWebbioUtility object
 * @author      zkiwbbv
 */

/* global spartaStoreUtility */
// Utility implementation here.
// Utilities can export anything: singletons, classes, even pure functions.

let page = '';
let counter = 0;
const HEART_BEAT_ERROR_STATUSES = {
  SDK_BLOCKED: 'sdkBlocked'
};
class AhWebbioUtility {
  constructor(options) {
    this.parentModule = options.context;
    this.parentModule.ahCawTransportUtility = options.ahCawTransportUtility;
    this.heartBeatIntervalMs = 5000;
    this.maxCheckAttempts = 3;
    this.heartBeatEventsCounter = 0;
    this.heartBeatStatus = '';
    this.heartBeatInterval = this.heartBeatIntervalMs;
    this.errorList = {
      "ERROR(701)": "true",
      "ERROR(702)": "true",
      "ERROR(703)": "true",
      "ERROR(704)": "true",
      "ERROR(705)": "true",
      "ERROR(706)": "true"
    };
    this.startListen();
  }

  /**
    * @function startListen
    * @description  Initial function to call the subsequent heart beat related functions.
    * @returns {undefined}
  */
  startListen() {
    this.parentModule;
    this._setHeartBeatListener();
    setInterval(this._checkHeartBeatStatus.bind(this), this.heartBeatInterval);
  }

  /**
    * @function _setHeartBeatListener
    * @description  Sets heart beat status.
    * @returns {undefined}
  */
  _setHeartBeatListener() {
    const main = this.parentModule;
    const DATA_TYPE = 'cdHeartbeat';
    window.addEventListener('message', event => {
      if (event.data.type === DATA_TYPE) {
        main.ahWebbio.heartBeatEventsCounter += 1;
        main.ahWebbio.heartBeatStatus = event.data.data;
      }
    });
  }

  /**
    * @function _checkHeartBeatStatus
    * @description  Use cases of heart beat statuses.
    * @returns {undefined}
  */
  _checkHeartBeatStatus() {
    const main = this.parentModule;
    let ahvcCookieHeartBeat = '';
    document.cookie.split('; ').forEach(function (row) {
      if (row.startsWith('AHVC=')) {
        ahvcCookieHeartBeat = row;
      }
    });
    let ahvcCookieHeartBeatValue = ahvcCookieHeartBeat.split('invokeHeartBeat:')[1].split(":")[0];
    if (ahvcCookieHeartBeatValue === 'true') {
      main.ahWebbio.maxCheckAttempts -= 1;
      if (main.ahWebbio.maxCheckAttempts === 0 && main.ahWebbio.heartBeatEventsCounter === 0) {
        main.ahWebbio._sendheartbeatapifailureStatus(HEART_BEAT_ERROR_STATUSES.SDK_BLOCKED);
      }
      if (main.ahWebbio.heartBeatStatus === 'Ok') {
        console.log("heartBeat status is Ok");
      } else if (typeof main.ahWebbio.heartBeatStatus === 'object') {
        for (let errorCode in main.ahWebbio.errorList) {
          if (main.ahWebbio.errorList[errorCode] === 'true') {
            main.ahWebbio.heartBeatStatus.forEach(function (code) {
              if (code === errorCode) {
                main.ahWebbio.errorList[errorCode] = 'false';
                main.ahWebbio._sendheartbeatapifailureStatus();
              }
            });
          }
        }
      }
    }
  }

  /**
    * @function _sendheartbeatapifailureStatus
    * @description  Triggers Heart beat API - captureJsStatus.
    * @param {String} error - Error String.
    * @returns {undefined}
  */
  _sendheartbeatapifailureStatus(error) {
    const main = this.parentModule;
    let requestPayload = "";
    if (error === HEART_BEAT_ERROR_STATUSES.SDK_BLOCKED) {
      requestPayload = {
        jsstatus: ["ERROR(699)"]
      };
    } else {
      requestPayload = {
        jsstatus: this.heartBeatStatus
      };
    }
    const ajaxOptions = {
      method: "POST",
      data: JSON.stringify(requestPayload),
      url: main.apiEndPoints.captureJsStatus,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      dataType: 'json'
    };
    ahTransportUtility._serviceCall(ajaxOptions, response => {}, error => {});
  }

  /**
    * @function callOptionB
    * @description  Appends vendb URLs to the script.
    * @param {String} pageContext - Context name of the current page.
    * @returns {undefined}
  */
  callOptionB(pageContext) {
    this.parentModule;
    let scriptTagOptionB = document.createElement('script');
    let lleUrl = window.location.host.indexOf('helix.ecnp') > -1 ? true : false;
    let optionBCdnUrl = '';
    page = pageContext;
    if (lleUrl) {
      optionBCdnUrl = 'https://uat-secure-' + window.sparta.env.split('_')[0] + '-helix.bac-assets.com/sparta/client/helper/spa-assets/components/utilities/client-helper/behbio/vendb-lle/5.0.0/js/vendb-lle.js';
    } else {
      optionBCdnUrl = 'https://secure' + window.sparta.env.split('_')[0].slice(-1) + '.bac-assets.com/sparta/client/helper/spa-assets/components/utilities/client-helper/behbio/vendb/5.0.0/js/vendb.js';
    }
    scriptTagOptionB.setAttribute('src', optionBCdnUrl);
    document.getElementsByTagName('head')[0].appendChild(scriptTagOptionB);
  }

  /**
    * @function iaCall
    * @description  Triggers iac service call.
    * @returns {undefined}
  */
  iaCall() {
    const main = this.parentModule;
    const ajaxOptions = {
      method: 'GET',
      url: main.apiEndPoints.iac + '?dfp=true',
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        'cache-control': 'no-cache'
      },
      dataType: 'text'
    };
    ahTransportUtility._serviceCall(ajaxOptions, response => {
      this.scriptLoadFunctions();
    }, error => {
      main.ahWebbio._triggerUiWebServerLogger('BehBio SDK is not loaded due to iacall');
    });
  }

  /**
    * @function scriptLoadFunctions
    * @description  Captures CSID cookie.
    * @returns {undefined}
  */
  scriptLoadFunctions() {
    let csidCookie = '';
    const main = this.parentModule;
    document.cookie.split('; ').forEach(function (row) {
      if (row.startsWith('CSID=')) {
        csidCookie = row;
      }
    });
    if (csidCookie) {
      let csidCookieValue = csidCookie.split(':')[0].split('CSID=')[1];
      main.ahWebbio.sendCsidContext(csidCookieValue, page);
    } else {
      main.ahWebbio._triggerUiWebServerLogger('BehBio SDK is not loaded due to cookie');
    }
  }

  /**
    * @function sendCsidContext
    * @description  Sends the CSID cookie value and page context to the cdApi object.
    * @param {String} csidCookieValue - CSID cookie value to be set as Customer Session Id.
    * @param {String} page - Context name of the current page.
    * @returns {undefined}
  */
  sendCsidContext(csidCookieValue, page) {
    const main = this.parentModule;
    let waitTimeout = 250;
    if (typeof cdApi === 'object') {
      cdApi.setCustomerSessionId(csidCookieValue);
      cdApi.changeContext(page);
      main.ahWebbio._triggerUiWebServerLogger("BehBio SDK is loaded with csid and pageContext", `:${csidCookieValue}:${page}`);
      main.ahWebbio.performFlush();
    } else {
      if (counter <= 60) {
        if (counter > 40) {
          waitTimeout = 1000;
        }
        let multipler = counter > 40 ? counter - 30 : counter;
        main.ahWebbio._triggerUiWebServerLogger("BehBio SDK is not loaded in miliseconds", ":" + multipler * waitTimeout);
        window.setTimeout(function () {
          main.ahWebbio.sendCsidContext(csidCookieValue, page);
        }, waitTimeout);
        counter = counter + 1;
      } else {
        main.ahWebbio._triggerUiWebServerLogger('BehBio SDK is not loaded due to web SDK error');
      }
    }
  }

  /**
    * @function _triggerUiWebServerLogger
    * @description  Triggers UI webserver logger to log the statements.
    * @param {String} error - Error String.
    * @returns {undefined}
  */

  _triggerUiWebServerLogger(message, param) {
    const main = this.parentModule;
    let loggerWebRequest = new XMLHttpRequest();
    let encryptedMessage = btoa(message);
    let encryptedHref = btoa(window.location.href);
    if (param === undefined) {
      param = "";
    }
    const appendErrorUrl = "?m=" + encryptedMessage + param + "&r=" + encryptedHref;
    loggerWebRequest.open("GET", main.apiEndPoints.uiLoggerUrl + appendErrorUrl, true);
    loggerWebRequest.setRequestHeader('Content-type', 'application/json');
    loggerWebRequest.setRequestHeader('accept', 'application/json');
    loggerWebRequest.setRequestHeader('cache-control', 'no-cache');
    loggerWebRequest.send();
  }

  /**
    * @function performFlush
    * @description  Triggers flush data events.
    * @returns {undefined}
  */
  performFlush() {
    const main = this.parentModule;
    if (document.readyState === 'complete') {
      main.ahWebbio.flushdataevents();
    } else {
      document.addEventListener('readystatechange', function () {
        if (document.readyState === 'complete') {
          main.ahWebbio.flushdataevents();
        }
      });
    }
  }

  /**
    * @function flushdataevents
    * @description  Flushes the data events.
    * @returns {undefined}
  */
  flushdataevents() {
    var element_array = ['signIn', 'passcode1', 'tlpvt-passcode-input', 'signin-with-mobile-app', 'signin-with-mobile-app-button', 'signin-pwdless', 'signin-pwdless-button', 'signin-pwdless-link', 'signin-with-mobile-app-link', 'signInWithMobileAppLink', 'signin-with-mobile-app-link-text', 'signin-with-passcode-text', 'signin-mobile-app', 'signin-with-passcode', 'signin-with-windows-hello', 'onlineId1', 'oid', 'pass', 'secure-signin-submit'];
    for (var i = 0; i < element_array.length; i++) {
      var checkElement = document.getElementById(element_array[i]);
      if (checkElement) {
        //hovering on the button with the cursor
        checkElement.addEventListener('mouseenter', function () {
          console.log('Mouse Enter Event - Flushing Data from authhub');
          cdApi.client.flush();
        }, {
          capture: true
        });
        //clicking on the button before releasing
        checkElement.addEventListener('mousedown', function () {
          cdApi.client.flush();
        }, {
          capture: true
        });
        //clicking on the button before releasing
        checkElement.addEventListener('keydown', function (event) {
          if (event.keyCode == 13 || event.keyCode == 32) {
            cdApi.client.flush();
          }
        }, {
          capture: true
        });
        // touch: clicking on the button before releasing
        checkElement.addEventListener('touchstart', function () {
          cdApi.client.flush();
        }, {
          capture: true
        });
      }
    }
  }
}

export { AhWebbioUtility as default };
